import { render, staticRenderFns } from "./FieldsTableView.vue?vue&type=template&id=1bfa8f3e&scoped=true&"
import script from "./FieldsTableView.vue?vue&type=script&lang=js&"
export * from "./FieldsTableView.vue?vue&type=script&lang=js&"
import style0 from "./FieldsTableView.vue?vue&type=style&index=0&id=1bfa8f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa8f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfa8f3e')) {
      api.createRecord('1bfa8f3e', component.options)
    } else {
      api.reload('1bfa8f3e', component.options)
    }
    module.hot.accept("./FieldsTableView.vue?vue&type=template&id=1bfa8f3e&scoped=true&", function () {
      api.rerender('1bfa8f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableView/FieldsTableView.vue"
export default component.exports